import React from 'react';
import { connect } from 'react-redux';
import { Breadcrumbs } from '@leverege/ui-elements';
import { Attributes, DataSources } from '@leverege/ui-attributes';
import { History } from '@leverege/molten-core';
import { jsx as _jsx } from "react/jsx-runtime";
function RelationshipBreadcrumb(props) {
  const {
    relationship,
    mobile,
    extraCrumbs
  } = props;
  const crumbs = [];
  let parent = relationship;
  while (parent) {
    let name = parent.name;
    if (parent.objRef) {
      // eslint-disable-next-line react/destructuring-assignment
      name = props[`name:${parent.path}`] || name;
    }
    crumbs.push({
      name,
      tooltip: name,
      url: parent.url,
      relationship: parent
    });
    parent = parent.parent;
  }
  crumbs.reverse();
  if (extraCrumbs) {
    crumbs.push(...extraCrumbs);
  }
  if (crumbs.length <= 1) {
    return null;
  }
  const v = mobile ? 'mobileTopNavBreadcrumbs|topNavBreadcrumbs' : 'topNavBreadcrumbs';
  return /*#__PURE__*/_jsx(Breadcrumbs, {
    variant: v,
    crumbs: crumbs,
    onClick: onClick,
    eventData: props
  });
}
function onClick(evt) {
  const {
    data,
    breadCrumbData
  } = evt;
  const {
    dispatch
  } = breadCrumbData;
  // Look up query params from sessionStorage
  const q = sessionStorage.getItem(`q:${data?.relationship?.path}`);
  const qc = sessionStorage.getItem(`qc:${data?.relationship?.path}`);
  if (qc === data?.relationship?.objRefUrl) {
    dispatch(History.push(data.url + (q == null ? '' : `?${q}`)));
  } else {
    dispatch(History.push(data.url));
  }
}
export default connect((state, props) => {
  // This is to make sure the names are up to data
  const rtn = {};
  const {
    relationship
  } = props;
  let parent = relationship;
  while (parent) {
    if (parent.objRef) {
      let name = parent.name;
      const dObjRef = DataSources.withData(parent.objRef);
      name = Attributes.get('name', dObjRef) || name;
      rtn[`name:${parent.path}`] = name;
    }
    parent = parent.parent;
  }
  return rtn;
})(RelationshipBreadcrumb);